<template>
  <div class="page">
    <div class="cond-row">
      <div class="item" style="margin-right: 100px">
        <div style="margin-right: 10px">选择默认模板：</div>
        <Button type="primary" @click="showCheckedTemplate">{{
          !templateInfo.templateId ? "选择模板" : templateInfo.templateName
        }}</Button>
      </div>
    </div>
    <Button
      class="submit-btn btn-height45"
      :loading="loading"
      type="primary"
      @click="onConfirm"
      >确认提交</Button
    >
    <templateListModal
      :show.sync="templateListModalVisibility"
      @onChecked="checkedTemplate"
    ></templateListModal>
  </div>
</template>

<script>
import { getTemplatesDefault, templatesDefaultSave } from "api/domain.js";
import templateListModal from "components/template/templateListModal.vue";
export default {
  name: "templateDefault",
  components: {
    templateListModal,
  },
  data() {
    return {
      templateInfo: {},
      loading: false,
      templateListModalVisibility: false,
    };
  },
  mounted() {
    this.req_getTemplatesDefault();
  },
  methods: {
    async req_getTemplatesDefault() {
      try {
        const { code, data } = await getTemplatesDefault();
        if (code === 200) {
          this.templateInfo = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 打开选择模板
    showCheckedTemplate() {
      this.templateListModalVisibility = true;
    },
    // 选中模板回调
    checkedTemplate(val) {
      this.templateInfo = val;
      this.templateListModalVisibility = false;
    },
    async onConfirm() {
      this.loading = true;
      try {
        const { code } = await templatesDefaultSave({
          domainTemplateId: this.templateInfo.templateId,
        });
        this.loading = false;
        if (code === 200) {
          this.$Message.success("操作成功！");
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  background-color: #fff;
  padding: 20px;
  .submit-btn {
    margin-left: 20px;
    margin-top: 20px;
  }
}
.cond-row {
  display: flex;
  flex-wrap: wrap;
  line-height: 60px;
  .item {
    display: flex;
    align-items: center;
    margin: 0 20px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
